var map = {
	"./en/analytics.json": [
		65062,
		5062
	],
	"./en/auditLog.json": [
		24037,
		4037
	],
	"./en/casb.json": [
		97111,
		7111
	],
	"./en/common.json": [
		10859,
		859
	],
	"./en/endpoints.json": [
		76212,
		6212
	],
	"./en/footer.json": [
		86001,
		6001
	],
	"./en/onboarding.json": [
		49487,
		9487
	],
	"./en/policies.json": [
		39136,
		9136
	],
	"./en/policyTester.json": [
		47911,
		7911
	],
	"./en/settings.json": [
		25919,
		5919
	],
	"./en/siem.json": [
		62804,
		2804
	],
	"./en/user.json": [
		47705,
		7705
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 46088;
module.exports = webpackAsyncContext;